import { Component, ElementRef, EventEmitter, OnInit, Output,Renderer2, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/base/services/general/general.service';
import { PersistenciaService } from 'src/app/base/services/persistencia/persistencia.service';
import { UsuarioService } from 'src/app/base/services/usuario/usuario.service';
import { GlobalVariable } from 'src/app/global';
import { BaseComponent } from 'src/app/models/base-component';
import { ClientesService } from 'src/app/snapquick/services/clientes/clientes.service';
import { Util } from 'src/app/utils/utils';
import { CampeonatosService } from '../../services/campeonatos/campeonatos.service';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { Observable, of, Subject } from 'rxjs';
import { WebcamImage } from 'ngx-webcam';
import { GeminiApiService } from 'src/app/base/services/gemini-api/gemini-api.service';

declare const aplicarSubidaArchivo:any;

@Component({
    selector: 'app-registro-jugador',
    templateUrl: './registro-jugador.component.html',
    styleUrls: ['./registro-jugador.component.css'],
    standalone: false
})
export class RegistroJugadorComponent extends BaseComponent implements OnInit {

  jugador:any={persona:{}};
  equipo:any;
  @Output() alTerminar:EventEmitter<any>  = new EventEmitter<any>();
  imageChangedEvent: any = '';
  croppedImage: any = '';

  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  webcamImage: WebcamImage | null = null;

  usando_camara:boolean=false;

  @ViewChild('subir-foto-jugador') fileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('subir-foto-ci') fileInputCi!: ElementRef<HTMLInputElement>;

  constructor(
    public generalService:GeneralService,
    public persistenciaService:PersistenciaService,
    public usuarioService:UsuarioService,
    public modalService: NgbModal,
    private toastr: ToastrService,
    public clientesService:ClientesService,
    public campeonatosService:CampeonatosService,
  private geminiService: GeminiApiService) { 
      super(persistenciaService,modalService,generalService,usuarioService);
  }

  async ngOnInit(): Promise<void> {    
    if(this.jugador.id){

    }else{
      let codigo_nuevo=await this.obtenerUltimoCodigo(GlobalVariable.Dictionary.TIPO_CORRELATIVO_CODIGO_JUGADOR);
      this.jugador={   
          id_empresa:this.usuario.id_empresa,   
          id_equipo: this.equipo.id,
          codigo:codigo_nuevo,
          activo:true,
          persona:{
            activo:true
          }
      }
    }
    //aplicarSubidaArchivo('foto-jugador','preview-template-foto',this,'subirArchivoFoto','eliminarArchivoFoto',{maximo_tamano_archivo:10});
  }

  async validarFormularioRegistroJugador(){
		let res=true;
		if(!this.jugador.persona.ci){
			this.toastr.error("Debe especificar el numero de C.I. del jugador!");
			res=false;
		}
    if(!this.jugador.persona.nombres){
			this.toastr.error("Debe especificar el nombre del jugador!");
			res=false;
		}
    if(this.jugador.jugador_equipo){
      let duplicidad_equipo=this.jugador.jugador_equipo.filter(je => je.equipo.id_campeonato==this.equipo.id_campeonato && je.equipo.id_disciplina==this.equipo.id_disciplina && je.equipo.id_categoria==this.equipo.id_categoria && je.activo==true);
      if(duplicidad_equipo.length>0){
        if(this.equipo.id!=duplicidad_equipo[0].equipo.id){
          this.toastr.error("El jugador ya se encuentra registrado en otro equipo!");
			    res=false;
        }
      }
		}
    if(!this.jugador.id){
      let jugador:any=await this.verificarCiJugador();
      if(jugador){
        this.jugador=jugador;
        this.jugador.id_equipo=this.equipo.id,
        this.jugador.persona.fecha_nacimiento_texto=Util.convertirFechaAObjectoFecha(new Date(jugador.persona.fecha_nacimiento));
        this.toastr.info("Jugador con C.I. "+this.jugador.persona.ci+" encontrado");
			  res=false;
      }
    }
		return res;
	}

  async guardarJugador(){
		if(await this.validarFormularioRegistroJugador()){
			this.blockUI.start();
      this.jugador.id_equipo=this.equipo.id,
      this.jugador.persona.fecha_nacimiento=this.jugador.persona.fecha_nacimiento_texto?Util.convertirObjetoAfecha(this.jugador.persona.fecha_nacimiento_texto):null;
			if(this.jugador.id){
				this.campeonatosService.actualizarJugador(this.jugador).subscribe((res:any) => {
					this.blockUI.stop();
          this.imageChangedEvent=null;
					this.toastr.success(res.mensaje);
					this.alTerminar.emit(res);
				});
			}else{
				this.campeonatosService.guardarJugador(this.jugador).subscribe((res:any) => {
					this.blockUI.stop();
          if(res.tiene_error){
            this.toastr.error(res.mensaje);
            return;
          }
          //si el carnet ya existia el servidor reutiliza ese jugador y no se gasta el codigo nuevo
          if(!res.existente){
            this.actualizarUltimoCodigo(GlobalVariable.Dictionary.TIPO_CORRELATIVO_CODIGO_JUGADOR);
          }
          this.imageChangedEvent=null;
					this.toastr.success(res.mensaje);
					this.alTerminar.emit(res);
				});
			}
		}
		
	}

  subirArchivoFoto(file){
    let me=this;
    this.usando_camara=false;
		var fileToLoad = file.target.files[0];
			var fileReader = new FileReader();

			fileReader.onloadend = function() 
			{
				let base64EncodedImage = fileReader.result; // <--- data: base64
        me.jugador.persona.imagen=base64EncodedImage;
        me.fileChangeEvent(file);
        /*me.askGemini({
          inlineData: { data: base64EncodedImage, mimeType: file.target.files[0].type },
        });*/
			}
			fileReader.readAsDataURL(fileToLoad);	
      this.clearInput();
  }

  subirArchivoCi(file){
    let me=this;
    this.usando_camara=false;
		var fileToLoad = file.target.files[0];
			var fileReader = new FileReader();

			fileReader.onloadend = function() 
			{
				let base64EncodedImage = fileReader.result; // <--- data: base64
        //me.fileChangeEvent(file);
        me.askGemini({
          inlineData: { data: base64EncodedImage, mimeType: file.target.files[0].type },
        });
			}
			fileReader.readAsDataURL(fileToLoad);	
      this.clearInputCi();
  }

  clearInput(): void {
    if (this.fileInput) {
      this.fileInput.nativeElement.value = ''; // Resets the file input
      console.log('Input cleared');
    }
  }

  clearInputCi(): void {
    if (this.fileInputCi) {
      this.fileInputCi.nativeElement.value = ''; // Resets the file input
      console.log('Input cleared');
    }
  }

  eliminarArchivoFoto(file){
    let me=this;
		var fileToLoad = file;
			var fileReader = new FileReader();

			fileReader.onloadend = function() 
			{
				let base64EncodedImage = fileReader.result; // <--- data: base64
        me.jugador.persona.imagen=null;
			}
			fileReader.readAsDataURL(fileToLoad);	
  }
  
  cerrarComponente(){
    this.alTerminar.emit();
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    //this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl);
    // event.blob can be used to upload the cropped image
    this.jugador.persona.imagen=event.base64;
  }

  imageLoaded(image: LoadedImage) {
    // show cropper
  }
  cropperReady() {
      // cropper ready
  }
  loadImageFailed() {
      // show message
  }

  public triggerSnapshot(): void {
      this.trigger.next();
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public handleImage(webcamImage: WebcamImage): void {console.log("foto");
    this.webcamImage = webcamImage;
    const dataUrl = webcamImage.imageAsDataUrl;
    this.jugador.persona.imagen=dataUrl;
    this.imageChangedEvent = { target: { result: webcamImage.imageAsDataUrl } };
    /*this.askGemini({
     inlineData: { data: dataUrl, mimeType: dataUrl.split(';')[0].split(':')[1]},
    });*/
  }

  public handleImageCi(webcamImage: WebcamImage): void {console.log("ci");
    this.webcamImage = webcamImage;
    const dataUrlci = webcamImage.imageAsDataUrl;
    //this.imageChangedEvent = { target: { result: webcamImage.imageAsDataUrl } };
    this.askGemini({
     inlineData: { data: dataUrlci, mimeType: dataUrlci.split(';')[0].split(':')[1]},
    });
  }

  public capturarImagen(): void {
    this.usando_camara=true;
    this.trigger.next();
  }

  public capturarImagenCi(): void {
    this.trigger.next();
  }

  async askGemini(image) {
    this.blockUI.start();
    console.log(image);
        image.inlineData.data=image.inlineData.data.split(',')[1];
        if (true) {
          try {
            //let geminiResponse = await this.geminiService.generateContent("ejemplo codigo angular para leer imagen y convertir json con gemini");
            //let geminiResponse = await this.geminiService.generateContent("Describe the image. Extract key information and represent it as a JSON object. Extract data as a product list. Focus on identifying objects, their attributes, and relationships between them. The output should be a valid JSON format. Include details like color, size, location, and any notable characteristics of the identified objects.", image);
            //let geminiResponse = await this.geminiService.generateContent("Convertir a JSON la planilla de partido, extrayendo datos, equipos, jugadores, goles amarillas y rojas.", image);
            let geminiResponse:any = await this.geminiService.leerCarnetDeIdentidad("Convertir a JSON carnet de identidad de bolivia para lectura de datos", image);
            //let geminiResponse = await this.geminiService.generateContent("can you summarize what is in the image and return the answer with json format", image);
            console.log(geminiResponse);
            let datos=JSON.parse(geminiResponse);
            console.log(datos);
            this.jugador.persona.fecha_nacimiento_texto=Util.convertirTextoAObjectoFecha(datos.date_of_birth);
            this.jugador.persona.nombres=datos["first_names"];
            this.jugador.persona.apellido_paterno=datos.last_names.split(" ")[0];
            this.jugador.persona.apellido_materno=datos.last_names.split(" ")[1];
            this.jugador.persona.ci=datos.id_number;
            //this.procesarDatosFactura(JSON.parse(geminiResponse));
            this.blockUI.stop();
            this.toastr.success("C.I. leido correctamente!");
          } catch (error) {
            this.blockUI.stop();
            this.toastr.error("Ocurrio un error al momento de leer el C.I.");
            console.log(error);
          }
        }
  }

  async verificarCiJugador(){
    let jugador:any=null;
    if(this.jugador.persona.ci!=="" && this.jugador.persona.ci!=="0" && this.jugador.persona.ci!==undefined && this.jugador.persona.ci!==null){
      this.blockUI.start();
      jugador=await this.campeonatosService.buscarCiJugador(this.usuario.id_empresa,this.jugador.persona.ci).toPromise();
      this.blockUI.stop();
    }
    return jugador;
  }

  async buscarCiJugador(){
    let jugador:any=await this.verificarCiJugador();
    if(jugador){
      this.jugador=jugador;
      this.jugador.id_equipo=this.equipo.id,
      this.jugador.persona.fecha_nacimiento_texto=Util.convertirFechaAObjectoFecha(new Date(jugador.persona.fecha_nacimiento));
      this.toastr.info("Jugador con C.I. "+this.jugador.persona.ci+" encontrado");
    }
  }

}
